import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Gauge, Fuel, Calendar } from "lucide-react";
import { fileUrl, euro, km } from "../lib/api";

const ease = [0.22, 1, 0.36, 1];

export const CarCard = ({ car, index = 0, wide = false }) => {
  const img = car.images?.[0];
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, ease, delay: (index % 3) * 0.08 }}
      className={wide ? "md:col-span-2" : ""}
    >
      <Link
        to={`/occasions/${car.id}`}
        data-testid={`car-card-${car.id}`}
        className="group block bg-surface border border-border overflow-hidden hover:border-primary/40 transition-colors duration-300"
      >
        <div className={`relative overflow-hidden ${wide ? "aspect-[16/9]" : "aspect-[4/3]"} bg-[#eef2f0]`}>
          {img ? (
            <img
              src={fileUrl(img)}
              alt={`${car.merk} ${car.model}`}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
            />
          ) : (
            <div className="w-full h-full grid place-items-center text-text-muted">Geen foto</div>
          )}
          {car.verkocht && (
            <span className="absolute top-4 left-4 bg-text-main text-white text-xs font-bold tracking-widest uppercase px-3 py-1.5">
              Verkocht
            </span>
          )}
          {car.uitgelicht && !car.verkocht && (
            <span className="absolute top-4 left-4 bg-accent text-primary text-xs font-bold tracking-widest uppercase px-3 py-1.5">
              Uitgelicht
            </span>
          )}
        </div>
        <div className="p-6">
          <div className="flex items-start justify-between gap-4">
            <div>
              <p className="text-xs font-bold tracking-[0.18em] uppercase text-primary">{car.merk}</p>
              <h3 className="font-display font-bold text-xl text-text-main mt-1 leading-tight">{car.model}</h3>
            </div>
            <p className="font-display font-black text-xl text-text-main whitespace-nowrap">{euro(car.prijs)}</p>
          </div>
          <div className="mt-5 flex flex-wrap gap-x-5 gap-y-2 text-sm text-text-muted">
            <span className="flex items-center gap-1.5"><Calendar size={15} /> {car.bouwjaar}</span>
            <span className="flex items-center gap-1.5"><Gauge size={15} /> {km(car.kilometerstand)}</span>
            <span className="flex items-center gap-1.5"><Fuel size={15} /> {car.brandstof}</span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};
